<template>
    <div class="Message" :class="isUser ? 'user' : 'bot'" style="position: relative">
        <div v-if="isAdmin" class="supporter">
            {{`${supporter.admin.name} - ${supporter.admin.email}`}}
        </div>
        <button v-if="showClose" style="right: 10px;top:5px;position: absolute;z-index: 100" @click="closeMessage=true">
          <img src="/icon/close.svg" alt="" width="16px" height="16px">
        </button>
        <div class="bottom">
            <div class="content-container">
              <div class="">
                <component v-bind="componentProps"></component>  
              </div>
              <v-layout
                    align-center
                    justify-end
                    class="resend-container"
                    v-if="!isUser && message.status && message.status === -1"
                >
                    <v-menu
                        left
                        nudge-left=90
                        darkcolor="#16171de6"
                        :close-on-content-click="false"
                        content-class="always-top"
                    >
                        <template v-slot:activator="{on}">
                            <div v-on="on" class="resend-btn">
                                <img src="/icon/warning.svg" alt="warning" :id="'error-tooltip-' + message.id">
                                <span style="color: #e53737">
                                    {{ $t("sendFail") | capitalize }}
                                </span>
                            </div>
                        </template>
                        <div class="send-fail-error">
                            <pre style="max-width: 700px; max-height: 500px; overflow-y: auto; white-space: pre-wrap;">
                                {{ message.error_message }}
                            </pre>
                            <v-layout justify-end small>
                                <v-btn color="primary" @click="copySendFailedError">
                                    {{$t('copy')}}
                                </v-btn>
                            </v-layout>
                        </div>
                    </v-menu>
                    <div class="resend-btn" @click="resendMessage">
                        <v-progress-circular v-if="resending"
                            indeterminate
                            size="14"
                            width="3"
                            color="grey"
                        ></v-progress-circular>
                        <img src="/icon/resend.svg" alt="resend">
                        <span style="color: #888A9A">{{ $t("resend") | capitalize }}</span>
                    </div>
                </v-layout>
            <div v-else-if="isLastSeenMsg" class="sent-status">
                <img src="/icon/eye.svg" alt="eye">
                {{$t('seen')}}
            </div>
            <div v-else-if="isSentMsg" class="sent-status">
                {{$t('sent')}}
            </div>
            </div>
            <div class="icon-container">
                <div class="avatar">
                    <v-avatar v-if="isUser" color="#4A699A" size="40">
                        <span style="color: #fff">
                            {{$AppService.createTextImage(customer.name)}}
                        </span>
                    </v-avatar>
                    <v-avatar v-if="isAdmin" color="#0052CC" size="40">
                        <span v-if="supporter.admin" style="color: #fff">
                            {{ $AppService.createTextImage(supporter.admin.name) }}
                        </span>
                    </v-avatar>
                    <v-avatar v-if="isBot" color="#0052CC" size="40">
                        <v-icon color="#FFFFFF">mdi-robot</v-icon>
                    </v-avatar>
                </div>
                <div class="time">{{ timeFormat(message.created_time) }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
import MessageContentCarousel from "components/message-box/content/MessageContentCarousel";
import MessageContentImage from "components/message-box/content/MessageContentImage";
import MessageContentText from "components/message-box/content/MessageContentText";
import MessageContentQuickReply from "components/message-box/content/MessageContentQuickReply";
import MessageContentFile from "components/message-box/content/MessageContentFile";
import messageHandler from "@/services/message_handlers/supporter_handler_message";
import MessageContentUploading from "components/message-box/content/MessageContentUploading";
import MessageContentEmail from "components/message-box/content/MessageContentEmail";
import MessageContentUserLocation from "components/message-box/content/MessageContentUserLocation";
import MessageContentRequestUserLocation from "components/message-box/content/MessageContentRequestUserLocation";

import MessageContentSticker from "components/message-box/content/MessageContentSticker";
import {mapState} from "vuex";
import MessageContentRating from "components/message-box/content/MessageContentRating";
import Vue from "vue";
import BotService from "../../../services/bot.service";

const ChatLogSource = {
    RECEIVE: 1,  // tin nhắn nhận từ người dùng
    SEND: 2,  // tin nhắn từ hệ thống gửi cho người dùng
};

const MessageSource = {
    NORMAL: 1,  // Tin nhắn bình thường ngời dùng vs bot, bot vs ng
    SYSTEM: 2,  // Tin nhắn từ hệ thống tới người dùng (broadcast) -> Deprecated
    ADMIN: 3,  // Admin gửi tin nhắn đến người dùng, người dùng chat với admin
    SEND_BROADCAST: 4,  // Send broadcast
    SEND_REMINDER: 5,  // Send reminder
    CALL_SEND_MESSAGE_API: 6,  // Send message controllers
};

const MessageContentMap = {
    'image': MessageContentImage,
    'zalo_list_template': MessageContentImage,
    'carousel': MessageContentCarousel,
    'text': MessageContentText,
    'payload': MessageContentText,
    'quick_reply': MessageContentQuickReply,
    'file': MessageContentFile,
    'uploading': MessageContentUploading,
    'email': MessageContentEmail,
    'user_send_location': MessageContentUserLocation,
    'request_users_location': MessageContentRequestUserLocation,
    'sticker': MessageContentSticker,
    'rating': MessageContentRating
}

export default {
    name: "Message",
    props: {
        message: Object,
        customer: Object,
        isLastSeenMsg: false,
        isSentMsg: false,
        resending: false,
        showClose: false,
        quoteMessageId: null,
        botCode:'',
        senderId:'',
    },
    data () {
        let isUser = this.message.source === ChatLogSource.RECEIVE
        let isBot = this.message.sender_type !== MessageSource.ADMIN && this.message.source === ChatLogSource.SEND
        const isChatWithAgent = this.message.source === ChatLogSource.RECEIVE && this.message.sender_type === MessageSource.ADMIN
        return {
            isUser: isUser,
            isBot: isBot,
            isChatWithAgent: isChatWithAgent,
            isAdmin: this.message.sender_type === MessageSource.ADMIN && this.message.source === ChatLogSource.SEND,
            isFirstMsg: this.message.isFirstMsg,
            isLastMsg: this.message.isLastMsg,
            supporter: this.message.supporter ? JSON.parse(this.message.supporter) : {},
            componentProps: {
                is: MessageContentMap[this.message.type],
                content: typeof this.message.content === 'string' ? JSON.parse(this.message.content) : this.message.content,
                isUser: isUser,
                isBot: isBot,
                isChatWithAgent: isChatWithAgent,
                chatlog_id: this.message.id,
                react_icon: this.message.react_icon,
                isDeleted: this.message.isDeleted,
                quoteProps:null,
                isQuoted: !this.showClose,
            },
            closeMessage:false,
            quoteProps: null,
        }
    },
    computed: {
      ...mapState(['notifyBotChat'])
    },
    async mounted() {
      if(this.message.content.quoted_message_id){
        try {
          let res = await BotService.adminGetChatLogById(this.botCode,this.senderId,this.message.content.quoted_message_id);
          let quoteMessage = res.data?.message;
          quoteMessage = typeof quoteMessage === 'string' ? JSON.parse(quoteMessage) : quoteMessage?.content;
          this.quoteProps = this.getDynamicComponent({
            ...quoteMessage,
            source: res.data.source,
            sender_type: res.data.sender_type
          });
        }catch (_) {
          
        }
      } 
    },
    methods: {
        timeFormat (time) {
            return moment(time).format('HH:mm')
        },
        resendMessage() {
            if (this.resending) return;
            let chatlog_id = this.message.id;
            let bot_code = this.$store.state.bot.code;
            let sender_id = this.$store.state.chatView.customer._id.sender_id;
            this.resending = true;
            messageHandler.resend_message(bot_code, sender_id, chatlog_id).catch(e => {
                if (e.response && e.response.data) {
                    let errorMessage = 'Resend failed: ' + e.response.data;
                    this.$AppService.toastError(errorMessage)
                } else {
                    this.$AppService.toastError('Resend failed.')
                }
            }).finally(() => {
                this.resending = false;
            })
        },
        copySendFailedError() {
            this.$utils.copyToClipboard(this.message.error_message, this.$t('copiedToClipboard'))
        },
        getDynamicComponent(message){
          let isUser = message.source === ChatLogSource.RECEIVE;
          let isBot = message.sender_type !== MessageSource.ADMIN && message.source === ChatLogSource.SEND;
          const isChatWithAgent = message.source === ChatLogSource.RECEIVE && message.sender_type === MessageSource.ADMIN;
          console.log(message)
          return {
            is: MessageContentMap[message.type],
            content: typeof message.content === 'string' ? JSON.parse(message.content) : message.content,
            isUser: isUser,
            isBot: isBot,
            isChatWithAgent: isChatWithAgent,
            chatlog_id: message.id,
            react_icon: message.react_icon,
            isDeleted: message.isDeleted,
            quoteProps:null,
            customer: this.customer,
            createdTime: message.createdTime,
            message_type: message.type
          }
        }
    },
  watch: {
    notifyBotChat(val) {
      const data = val && val.data ? val.data : {};
      if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_REACTED_MESSAGE) {
        if (this.message.id === data.chat_log._id) {
          Vue.set(this.componentProps, "react_icon", data.chat_log.react_icon)
          }
        } else if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.USER_DELETED_MESSAGE) {
            if (this.message.id === data.chat_log._id) {
                Vue.set(this.componentProps, "is", MessageContentText)
                Vue.set(this.componentProps, "content", {
                    "text": "This message has been deleted."
                })
                Vue.set(this.componentProps, "isDeleted", true)
            }
        }
      },
    closeMessage(){
      this.$emit('close',true);
    },
    message(val){
      this.componentProps= this.getDynamicComponent(val);
    },
    quoteProps(val){
      this.componentProps.quoteProps = val;
    }
  }
};
</script>
<style lang="scss" scoped src="../../style/message-box.scss"></style>
